<template>
    <div :class="[$style['multi-select'], {[$style['is-open']]: isOpen}, {[$style['is-change']]: valueDef}]"
         ref="select">
        <div :class="$style['multi-select__toggle']" @click="toggleOpen">
            <span :class="$style['multi-select__caption']">{{ placeholder }}</span>
            <span :class="$style['multi-select__fake-arrow']">
                <svg width="10"
                     height="6"
                     viewBox="0 0 10 6"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#ffffff"/>
                </svg>
            </span>
        </div>

        <div v-if="isMobile && isOpen" :class="$style['multi-select__fix']"
             ref="fixedList">
            <div :class="$style['multi-select__fix-top']">
                <div :class="[$style['multi-select__fix-label'], 'h4']">{{ label }}</div>
                <div :class="$style['multi-select__fix-close']"
                     @click="closeFixedList">
                    <svg viewBox="0 0 32 32"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" fill="#22242B"/>
                        <path d="M16 15.3685L10.6316 10L10 10.6316L15.3685 16L10.0001 21.3684L10.6316 22L16 16.6316L21.3684 21.9999L21.9999 21.3683L16.6316 16L22 10.6317L21.3684 10.0001L16 15.3685Z"
                              fill="white"/>
                    </svg>
                </div>
            </div>

            <div :class="$style['multi-select__fix-content']">
                <ul :class="$style['multi-select__list']">
                    <li v-for="option in select.options" :key="option.id" :class="$style['multi-select__item']">
                        <input type="checkbox"
                               :name="select.name"
                               :id="`${select.name}-${option.id}`"
                               :value="option.value"
                               :class="$style['multi-select__input']"
                               v-model="option.selected"
                               @change="change(option)">

                        <label :for="`${select.name}-${option.id}`" :class="$style['multi-select__label']">
                            <span :class="$style['multi-select__label-top']">
                                <span>{{ option.text }}</span>

                                <span :class="$style['multi-select__fake']">
                                    <svg width="15"
                                         height="10"
                                         viewBox="0 0 15 10"
                                         fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.5 4.5L6 9L14 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </span>

                            <span v-if="option.pass === false || !Number(option.flats)"
                                  :class="$style['multi-select__no-result']">
                                Нет результатов
                            </span>
                        </label>
                    </li>
                </ul>
            </div>

            <div :class="$style['multi-select__fix-submit']" @click="closeFixedList">Применить</div>
        </div>

        <div v-else :class="$style['multi-select__list-wrap']" :style="{maxHeight: heightList}" ref="list">
            <ul :class="$style['multi-select__list']">
                <li v-for="option in select.options" :key="option.id" :class="$style['multi-select__item']">
                    <input type="checkbox"
                           :name="select.name"
                           :id="`${select.name}-${option.id}`"
                           :value="option.value"
                           :class="$style['multi-select__input']"
                           v-model="option.selected"
                           @change="change(option)">

                    <label :for="`${select.name}-${option.id}`" :class="$style['multi-select__label']">
                        <span :class="$style['multi-select__label-top']">
                            <span>{{ option.text }}</span>

                            <span :class="$style['multi-select__fake']">
                                <svg width="15"
                                     height="10"
                                     viewBox="0 0 15 10"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 4.5L6 9L14 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </span>

                        <span v-if="option.pass === false || !Number(option.flats)"
                              :class="$style['multi-select__no-result']">
                            Нет результатов
                        </span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Utils from '../../../helpers/Utils';

    export default {
        props: ['select', 'slug', 'label'],

        data: () => ({
            isOpen: false,
            heightList: 0,
            isMobile: window.innerWidth < 960
        }),

        computed: {
            placeholder() {
                const selected = this.select.options.filter((option) => {
                    return option.selected;
                });

                const text = selected.map(option => option.text);

                if (text.length) {
                    return text.join(', ');
                }

                return this.select.placeholder;
            },

            valueDef() {
                return this.select.options.filter((option) => {
                    return option.selected;
                }).length;
            }
        },

        watch: {
            isMobile(val) {
                setTimeout(() => {
                    if (!val && this.isOpen) {
                        this.showList();
                    }
                }, 0);
            }
        },

        methods: {
            change() {
                const options = this.select.options.filter((option) => {
                    return option.selected;
                });

                this.$emit('change', this.slug, options);
            },

            toggleOpen() {
                if (window.innerWidth < 960) {
                    this.isOpen = true;
                    Utils.bodyFixed(this.$refs.fixedList);
                } else {
                    if (this.isOpen) {
                        this.hideList();
                    } else {
                        this.showList();
                    }
                }
            },

            closeFixedList() {
                Utils.bodyStatic();
                this.isOpen = false;
            },

            hideList() {
                this.isOpen = false;
                this.heightList = '0px';
            },

            showList() {
                this.isOpen = true;
                this.heightList = `${this.getHeightList()}px`;
            },

            getHeightList() {
                if (!this.$refs.list) {
                    return 0;
                }

                return this.$refs.list.scrollHeight + 10;
            },

            setHeightOnResize() {
                if (this.isOpen) {
                    this.heightList = `${this.getHeightList()}px`;
                }
            },

            clickOutside() {
                const target = event.target;
                const selectWrapper = this.$refs.select;

                if (!this.isDescendant(selectWrapper, target)) {
                    this.hideList();
                }
            },

            isDescendant(parent, child) {
                let node = child.parentNode;

                while (node != null) {
                    if (node === parent) {
                        return true;
                    }
                    node = node.parentNode;
                }

                return false;
            },

            resize() {
                this.setHeightOnResize();

                this.isMobile = window.innerWidth < 960;
            }
        },

        mounted() {
            window.addEventListener('resize', this.resize);
            document.body.addEventListener('click', this.clickOutside, false);
        },

        destroyed() {
            window.removeEventListener('resize', this.resize);
            document.body.removeEventListener('click', this.clickOutside, false);
        }
    }
</script>

<style lang="scss" module>
    @import "./MultiSelect";
</style>

<style lang="scss">
    .toggle-enter-active,
    .toggle-leave-active {
        @include transition(opacity);
    }

    .toggle-enter, .toggle-leave-to {
        max-height: 0;
    }
</style>
